import { createGlobalStore } from 'hox';
import { useState } from 'react';

//严格控制showParams和allParams的变化，
//比如切换address时， 现获取到新address的assetConfig配置，再去触发 getWalletBalance的两次调用
//或者custom asset
export const [useWalletChangeParams] = createGlobalStore(() => {
  const [showParams, setShowParams] = useState<{
    address: string;
    tokenAddresses: string[];
  }>();

  const [allParams, setAllParams] = useState<{
    address: string;
    tokenAddresses: string[];
  }>();
  return {
    showParams,
    setShowParams,
    allParams,
    setAllParams,
  };
});
